import { Navigate, Outlet } from "react-router-dom";
import useSharedData from "../hooks/useSharedData";

function ProtectedAuthRoutes() {
  const { isAuthed } = useSharedData();

  if (!isAuthed) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}

export default ProtectedAuthRoutes;
